export const searchStatisticsContext = {
  ratioByPlatform: '/search-service/api/external/dashboard/ratio/platform',
  ratioByAuthorizedUsers: '/search-service/api/external/dashboard/ratio/authorizedUsers',
  ratioByStatus: '/search-service/api/external/dashboard/ratio/status',
  queryByTrends: '/search-service/api/external/dashboard/growthPercentage',
};
